import { createTheme } from '@mui/material/styles';

// ── Elaris Navy-Gold Theme ──────────────────────────────────────────────────
export const GOLD    = '#c9960c';        // primary gold
export const GOLD2   = '#e8b020';        // brighter gold hover
export const GOLDF   = '#f5c518';        // full-bright gold
export const GOLDG   = '#ffd84d';        // glow gold
export const DARK    = '#0b0d1e';        // deepest navy
export const NAVY    = '#0e1230';        // main navy bg
export const NAVY2   = '#141840';        // section navy
export const NAVY3   = '#1a2050';        // card navy
export const NAVYL   = '#202660';        // lighter navy
export const CREAM   = '#faf8f0';

// Glass card surface
export const CARD_BG = 'rgba(14,18,48,0.85)';

const theme = createTheme({
  palette: {
    primary: { main: GOLD },
    background: { default: NAVY },
    text: { primary: '#fff' },
  },
  typography: {
    fontFamily: "'DM Sans', sans-serif",
    h1: { fontFamily: "'Cinzel', Georgia, serif" },
    h2: { fontFamily: "'Cinzel', Georgia, serif" },
    h3: { fontFamily: "'Cinzel', Georgia, serif" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': { boxSizing: 'border-box' },
        html: { scrollBehavior: 'smooth' },
        body: { background: NAVY, color: '#fff' },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontFamily: "'DM Sans', sans-serif", fontWeight: 700 },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: { background: 'transparent' },
      },
    },
  },
});

export default theme;
